/*
  •	Copyright (c) 2024 Pegasystems Inc.
  •	All rights reserved.
*/

import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { SCOPE_TYPES } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import CaseAPIs from '../../rest-client/case-apis';
import EnvironmentInfo from '../../environment-info';
import type { Action } from '../../store/state/state-manager';
import ObjectTransformer from '../../utils/object-transformer';

const DXAPI_ERROR = 'Error occurred during ajax call at createObject Epic : ';

export const executeCreateExternalObjectRequest = (
  actionInPayload: Action['payload'],
  options: { removeActionPayload: any }
) => {
  const { class: caseClassName, context, viewType = SCOPE_TYPES.PAGE } = actionInPayload;

  const { removeActionPayload } = options;

  const pageName = actionInPayload?.pageName ? actionInPayload?.pageName : EnvironmentInfo.getDefaultCasePage();
  return from(
    CaseAPIs.createCase(caseClassName, {
      ...actionInPayload,
      pageName,
      viewType,
      context,
      retrieveActionViewForNewObject: true
    })
  ).pipe(
    map(({ response, headers }) => {
      ObjectTransformer.analyseResponse(response);
      return {
        response,
        actionInPayload,
        headers,
        removeActionPayload
      };
    }),
    logAndCatchError(DXAPI_ERROR, context)
  );
};

export default { executeCreateExternalObjectRequest };
